'use strict';

module.exports = {
    LANG: 'ja-jp',
    SIGN: 'サインイン',
    REGISTER: 'レジスター',
    QUICK_ACCESS: 'XXXへの高速アクセス',
    SIGN_JOIN: 'サインインまたは無料で参加する!',
    NOT_MEMBER: '会員ではありませんか。',
    ALREADY_MEMBER: 'AliExpress/Alibabaの会員ですか。',
    SHOW_ALL: 'すべてを表示',
    HIDE: '隠す'
};